<script lang="ts">
	import * as duckdb from '@duckdb/duckdb-wasm';
	import * as arrow from 'apache-arrow';
	import {tableFromIPC} from 'apache-arrow';
	import SliderRange from './Widgets/SliderRange.svelte'
	import InputBox from './Widgets/InputBox.svelte';
	import Dropdown from './Widgets/Dropdown.svelte';
	import { Row, Col, Grid, Item } from 'svelte-layouts';

	import { VegaLite } from "svelte-vega";
  	import type { VisualizationSpec, View } from "svelte-vega";

	import { payouts_chirps, payouts_arc } from "./codes/payout";
	import { clim_chirps } from "./codes/climatology"

	import { store } from './hooks/auth';
	import LoginComponent from './LoginComponent.svelte';


	var data_status = "Data not loaded";

	export let db: Promise<duckdb.AsyncDuckDB>;
	
	var data_loading_time = 0.0
	

	// async function loadDataSize() {
	// 	var stats = fs.lstatSync("../public/data/chirps.csv");
	// 	var fileSizeInBytes = stats.size;
	// 	console.log(fileSizeInBytes);
	// }
	// loadDataSize();

	async function loadData() {
		var start = Date.now()
		var dbhere = await db;
		const conn = await dbhere.connect()
		await conn.query(`
		CREATE TABLE chirps AS 
		SELECT * FROM "` + window.location.href + `data/chirps.csv"
		`);
		await conn.query(`
    	CREATE TABLE arc AS
        SELECT * FROM "` + window.location.href + `data/arc.csv"
		`);
		await conn.close();
		data_loading_time = Date.now() - start;
		data_status = "Data loaded!";
	}

	async function loadGeoLocations(){
		var admin2s = new Set()
		var dbhere = await db;
	 	const conn = await dbhere.connect();
		var res = await conn.query(`select * from chirps`);
		var structTable = res.toArray();
		for(var i=0; i < res.numRows; i++){
			admin2s.add(structTable[i].toJSON()['admin2'])
		}
		await conn.close();
		return admin2s;
	}

	async function payout(){
		var dbhere = await db;
	 	const conn = await dbhere.connect();
		if (param_dict['data_source'] == "chirps"){
			var stmt = await conn.prepare(payouts_chirps);
		} else if (param_dict['data_source'] == "arc"){
			var stmt = await conn.prepare(payouts_arc);
		}
		var res = await stmt.query(param_dict['admin2'],
									param_dict['year_start'],
									param_dict['year_end'],
									param_dict['dekcap'],
									param_dict['dekcap'],
									param_dict['sum_early_first'],
									param_dict['sum_early_last'],
									param_dict['sum_late_first'], 
									param_dict['sum_late_last'],
									param_dict['rolling_early_first'],
									param_dict['rolling_early_last']);
		var structTable = res.toArray()
		var table=[]
		for(var i=0; i < res.numRows; i++){
			table = table.concat(structTable[i].toJSON())
		}
		await conn.close();
		return table;
	}

	async function clim(){
		var dbhere = await db;
	 	const conn = await dbhere.connect();
		if (param_dict['data_source'] == "chirps"){
			var stmt = await conn.prepare(clim_chirps);
		} 
		// else if (param_dict['data_source'] == "arc"){
		// 	var stmt = await conn.prepare(payouts_arc);
		// }
		var res = await stmt.query(param_dict['admin2'],
									param_dict['year_start'],
									param_dict['year_end'],
									param_dict['dekcap'],
									param_dict['dekcap'],
									param_dict['dekcap'],
									param_dict['dekcap']);
		var structTable = res.toArray()
		var table=[]
		for(var i=0; i < res.numRows; i++){
			table = table.concat(structTable[i].toJSON())
		}
		await conn.close();
		return table;
	}
	
	

	async function update_param(key, value){
		param_dict[key] = value
		var data_payout = payout();
		data_payout.then(function(value){
		dataPayout = {table: value}
		})

		var climatology = clim();
		climatology.then(function(value){
		dataClimatology = {table: value}
		})
	}

	var param_dict = {
		data_source: "chirps",
		admin2: 'Chadiza',
		year_start: 1984,
		year_end: 2020,
		dekcap: 24,
		sum_early_first: 33,
		sum_early_last: 37,
		sum_late_first: 38,
		sum_late_last: 42,
		rolling_early_first: 33,
		rolling_early_last: 37
	}




	loadData();
	var admin2s = loadGeoLocations();
	let geo = []
	admin2s.then(function(value){
		geo = [...value]
	})
	
	let dataPayout = {
    table: [
    ]
  	}
	
	let dataClimatology = {table: []}
	
	var data_payout = payout();
  	data_payout.then(function(value){
		dataPayout = {table: value}
	})
	var climatology = clim();
	climatology.then(function(value){
		dataClimatology = {table: value}
	})

	const data_sources = ['chirps', 'arc'];


	let viewPayout: View;
	let specPayout: VisualizationSpec = {
	$schema: "https://vega.github.io/schema/vega-lite/v5.json",
	title:"Index Payout",
	data: {
		name: "table",
	},
	transform:[
      {fold: ['sum_early', 'sum_late', 'rolling_early']}
    ],
	width: 800,
	height: 250,
	mark: "bar",
	encoding:{
		x: {field: "year_ag"},
		y: {field: "value", type:"quantitative"},
      	color:{field: "key"},
      	xOffset:{field: "key"}
	}
	};
	$: viewPayout ? console.log("Vega-Lite view: ", viewPayout.data("table")) : "";

	let viewCombinedPayout: View;
  	let specCombinedPayout: VisualizationSpec = {
    $schema: "https://vega.github.io/schema/vega-lite/v5.json",
    title:"Combined Index Payout",
    data: {
      name: "table",
    },
    width: 800,
    height: 250,
    mark: "bar",
    encoding: {
      x: { field: "year_ag" },
      y: { field: "combined_payout", type: "quantitative" },
    },
  };
  $: viewCombinedPayout ? console.log("Vega-Lite view: ", viewCombinedPayout.data("table")) : "";

  let viewClimatology: View;
  let specClimatology: VisualizationSpec = {
    $schema: "https://vega.github.io/schema/vega-lite/v5.json",
    title: "Capped Climatology (black)",
    data: {
      name: "table"
    },
    width: 800,
    height: 250,
    layer: [
      {
        mark: "line",
        encoding: {
        x: {field: "DEKAD_ag", type: "nominal"},
        y: {field: "value", type: "quantitative"}
    }}
    ]
  };
  $: viewClimatology ? console.log("Vega-Lite view: ", viewClimatology.data("table")) : "";


	</script>


	<main>
	<!-- {#if $store != null } -->
	{#await db}
		<h1>Instantiating...</h1>
		{data_status}
	{:then db}
		<br>
		<div id="loader">
			Data Loading Time: {data_loading_time / 1000} seconds
		</div>
		<h1>Zambia Drought Index Insurance</h1>
		<h3>Index Parameters Optimization Application</h3>
		<Row>
		<Col>
			<Dropdown
			label={"District:"}
			default_val={geo[0]}
			var_name={"admin2"}
			update={update_param}
			options={geo}
			/>
			<SliderRange
			label={"Range of years (harvest) for index calculations"}
			min={1984}
			max={2021}
			default_min={1984}
			default_max={2021}
			min_var_name={"year_start"}
			max_var_name={"year_end"}
			update={update_param}
			/>
			<Dropdown
			label={"Select Rain Dataset for Index:"}
			default_val={data_sources[0]}
			var_name={"data_source"}
			update={update_param}
			options={data_sources}
			/>
			<InputBox
			label={"Select Dekad Cap for Simple Sum Windows:"}
			default_val={24}
			var_name={"dekcap"}
			update={update_param}
			/>
			<SliderRange
			label={"Early Simple Sum Agricultural Timing Parameters (dekad):"}
			min={25}
			max={43}
			default_min={33}
			default_max={37}
			min_var_name={"sum_early_first"}
			max_var_name={"sum_early_last"}
			update={update_param}
			/>

			<SliderRange
			label={"Late Simple Sum Agricultural Timing Parameters (dekad):"}
			min={32}
			max={48}
			default_min={38}
			default_max={42}
			min_var_name={"sum_late_first"}
			max_var_name={"sum_late_last"}
			update={update_param}
			/>
			<SliderRange
			label={"Early Rolling Agricultural Timing Parameters (dekad):"}
			min={25}
			max={43}
			default_min={33}
			default_max={37}
			min_var_name={"rolling_early_first"}
			max_var_name={"rolling_early_last"}
			update={update_param}
			/>
		</Col>
		<Col>
			<VegaLite data={dataPayout} spec={specPayout} view={viewPayout}/>
			<VegaLite data={dataPayout} spec={specCombinedPayout} view={viewCombinedPayout}/>
			<VegaLite data={dataClimatology} spec={specClimatology} view={viewClimatology}/>
		</Col>
		</Row>
	{/await}
	<!-- {:else}
	<LoginComponent/>
	{/if} -->
	</main>
